<template>
  <div>
    <h5 class="mb-5 questionlabel" v-if="showQuestionVal && question.question">
      {{ question.question }}
    </h5>
    <div class="vx-row my-5">
      <div
        class="vx-col w-full mb-2"
        v-for="(answer, index2) in question.answers"
        :key="indexVal + '_' + index2"
        :class="{ wrong: !answer.correct && value == answer.val }"
        v-if="isEditable"
      >
        <vs-radio
          v-model="val"
          @input="handleInput"
          :vs-name="'question_' + indexVal"
          class="checkbox_answer multiline"
          :vs-value="answer.val"
          :aria-label="answerLabel(answer, index2)"
        >
          <img
            :src="answer.image"
            :alt="answer.alt || ''"
            v-if="typeof answer.answerWithImage !== 'undefined' && answer.answerWithImage"
          />
          <span v-else>{{ answer.answer }}</span>
        </vs-radio>
      </div>
      <p
        class="my-2 mx-5"
        :class="{
          wrong: !answer.correct && value == answer.val,
          correct: answer.correct && value == answer.val,
        }"
        v-else
      >
        {{ answer.answer }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['question', 'value', 'isEditable', 'index', 'showQuestion'],
  data() {
    return {
      val: this.$props.value,
    };
  },
  methods: {
    // Some answer sets are images with no text at all (e.g. "which shape is more stable?").
    // `answer.alt` lets content supply a real description; the numbered fallback at least
    // makes the options distinguishable and selectable (WCAG SC 1.3.1 / 4.1.2).
    answerLabel(answer, index) {
      return answer.answer || answer.alt || `Option ${index + 1}`;
    },
    handleInput(e) {
      this.$emit('input', e);
    },
  },
  computed: {
    showQuestionVal() {
      if (typeof this.$props.showQuestion !== 'undefined')
        return this.$props.showQuestion !== 'false';
      return true;
    },
    indexVal() {
      if (typeof this.$props.index !== 'undefined') return this.$props.index;
      return 1;
    },
  },
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
}
.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}
.scale-header {
  background: #f5f5f5;
  padding-top: 5px;
  font-weight: 600;
}
</style>
